import { useMemo, useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import { axiosGetWithHeader, axiosPutWithHeader, ShowGenericAlertError } from "../../Common/axios";
import Collapse from "react-bootstrap/esm/Collapse";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import { SubmitResetClearButton } from "../../Client/ClientUtil";
import { useMediaQuery } from "react-responsive";

export function ProsperityChart ({menuArray,userData,clientData,eventData,handleEventKey,handleEventData}) {
  const [spinner, setSpinner] = useState('Loading - Prosperity Anayser');
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [prosData, setProsData] = useState([]);
  const [eventCategoryValues,setEventCategoryValues]=useState([]);
  const [planetCategory,setPlanetCategory] = useState([0,0,0,0,0,0,0,0,0]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [msgtitle, setMsgtitle] = useState('Error');
  const [msgbody, setMsgbody] = useState('');
  const [msgbutton, setMsgbutton] = useState('');
  const [showColumn, setShowColumn] = useState(false);
  const [showPlanetColor, setShowPlanetColor] = useState(false);
  const loop = [1,2,3];
  const handleColumn = ()=> setShowColumn(!showColumn);
  const handlePlanetColor = ()=> setShowPlanetColor(!showPlanetColor);
  const handleEvents = (key)=> handleEventKey(key);
  const handleAlertCallback = ()=> setErrorMessage(null);


  useMemo(() => {
    if(eventData!==null && eventData.userEvent!==null && eventData.userEvent.planetCombinedCategory!==null) {
      setPlanetCategory(eventData.userEvent.planetCombinedCategory.split(","));
    } else {
      setPlanetCategory([0,0,0,0,0,0,0,0,0]);
    }
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    if(eventData===null||eventData===undefined||eventData.currentEvent===null||eventData.currentEvent===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    var eventId = eventData.currentEvent.id;
    axiosGetWithHeader("/chart/prosperitychart/"+clientId+"/"+eventId,
      (response)=>{
        setProsData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setProsData([]);
        setSpinner(null);
      }
    );

    if(eventData!==null && eventData.currentEvent!==null) {
      setEventCategoryValues([
          eventData.currentEvent.primary,eventData.currentEvent.secondary,eventData.currentEvent.supportive,
          eventData.currentEvent.bad,eventData.currentEvent.worse,eventData.currentEvent.worst
       ]);
    }

  }, [userData,eventData]);

  function handleColorInput(event,planetIndex){
    const tempPlanetCategory = [...planetCategory];
    tempPlanetCategory[planetIndex]=event.target.value;
    setPlanetCategory(tempPlanetCategory);
  }

  function getTag(str){
    if(str===null||str==="") return "";
    var arr = str.split("/");
    for(var i=0; i<arr.length;i++) {
      if(arr[i]===null||arr[i]==="") continue;
      if(i===0) {
        arr[i]=<font color={getColor(arr[i])}><b>{arr[i]}</b></font>;
      } else {
        arr[i]=<>,<font color={getColor(arr[i])}><b>{arr[i]}</b></font></>;
      } 
    }
    return arr;
  }

  function getColor(value){
    if(value===null||eventData===null||eventData.currentEvent===null||eventData.allEventCategoryColor===null){
      return "black";
    }
    value = value.trim();

    for(var i=0; eventCategoryValues!==null && i<eventCategoryValues.length; i++){
      if(isExistinArray(eventCategoryValues[i],value)) {
        return eventData.allEventCategoryColor[i];
      }
    }
    return "black";
  }

  function isExistinArray(str,value) {
    if(str===null||str===undefined) return false;
    var array = str.split(",");
    for(var i=0;i<array.length;i++) {
      if(array[i].toString()===value) {
        return true;
      }
    }
    return false;
  }

  const handleSubmit =  (event) => {
    const data = {
      userId:userData.id,
      eventId: eventData.currentEvent.id,
      planetCombinedCategory: planetCategory.toString(),
    };
    axiosPutWithHeader("/chart/event/planetCombinedCategory", data,
      (response)=>{
        setMsgtitle("Prosperity");
        setMsgbutton("Close");
        if(response.data.code==='200') {
          handleEventData(userData.id,eventData.currentEvent.id);
          setMsgbody("Prosperity values updated successfully.");
        } else {
          setMsgbody("Error occurred while saving prosperity.");
        }
        setErrorMessage("Error");
      },
      (error)=>{
        setMsgtitle("Error");
        setMsgbody("Error occurred while saving");
        setMsgbutton("Close");
        setErrorMessage(error.message);
      }
    );      
    event.preventDefault();
  }
  
  function handleReset() {
    if(eventData!==null && eventData.userEvent!==null && eventData.userEvent.planetCombinedCategory!==null) {
      setPlanetCategory(eventData.userEvent.planetCombinedCategory.split(","));
    } else {
      setPlanetCategory([0,0,0,0,0,0,0,0,0]);
    }
  }

  function handleClear() {
      setPlanetCategory([0,0,0,0,0,0,0,0,0]);
  }

  return(<>
    {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
    { eventData===null || eventData===undefined || eventData.length===0 || userData===null || userData===undefined
          || clientData===null || clientData===undefined || prosData===null || prosData===undefined || prosData.length===0 ?<></>:
      <Collapse in={menuArray[2]} className="m-0 p-0">
        <Row id="prosperityChart" className="m-0 p-0">
          <Col xs={12} className="p-0 m-0 pt-1">
            <Row id="prosperity" className="m-0 p-0">
              <Col xs={0} lg={3} className="m-0 p-0">
                <table class="table table-hover align-middle caption-top m-0 p-0 text-center TableFont11">
                  <caption class="m-0 p-0 ps-2 pt-2"><h5 class="m-0 p-0">Prosperity Analyser</h5></caption>
                </table>
              </Col>
              <Col xs={12} lg={6} className="p-0 m-0 text-center">
                <Row id="heading" className="m-0 p-0">
                  <Col xs={0} lg={3} className="p-0 m-0 text-start">
                    <DropdownButton id="dropdown-basic-button" title={eventData.currentEvent.name} variant="light" class="m-0 p-0 me-2">
                      <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                      {Object.keys(eventData.allEvents).map((key, index) => {
                        const event = eventData.allEvents[key];
                        return Object.keys(event).map((key) => {
                          const value = event[key];
                          if(key<0) {
                            return <Dropdown.Divider/>
                          }
                          return <Dropdown.Item onClick={()=>handleEvents(key)} >{value}</Dropdown.Item>
                        })  
                      })}
                      </div>
                    </DropdownButton>
                  </Col>
                  <Col xs={0} lg={9} className="p-0 pt-0 m-0">
                  <div class="input-group m-0 p-0">
                    <input type="input" maxlength="10" class="form-control" title="Primary" value={eventData.currentEvent.primary===null?"":eventData.currentEvent.primary}/>
                    <input type="input" maxlength="10" class="form-control" title="Secondary" value={eventData.currentEvent.secondary===null?"":eventData.currentEvent.secondary}/>
                    <input type="input" maxlength="10" class="form-control" title="Supportive" value={eventData.currentEvent.supportive===null?"":eventData.currentEvent.supportive} />
                    <input type="input" maxlength="10" class="form-control" title="Bad" value={eventData.currentEvent.bad===null?"":eventData.currentEvent.bad}/>
                    <input type="input" maxlength="10" class="form-control" title="worse" value={eventData.currentEvent.worse===null?"":eventData.currentEvent.worse} />
                    <input type="input" maxlength="10" class="form-control" title="Worst" value={eventData.currentEvent.worst===null?"":eventData.currentEvent.worst} />
                  </div>
                  </Col>    
                </Row>
              </Col>
              <Col xs={0} lg={3} className="m-0 p-0 text-end">
              <button type="button" class="btn btn-outline-primary me-2" onClick={handlePlanetColor}>{showPlanetColor?"Hide Color":"Show Color"}</button>
              <button type="button" class="btn btn-outline-primary me-2" onClick={handleColumn}>{showColumn?"Hide Column":"Show Column"}</button>
              </Col>
            </Row>
            <Row id="prosperity1" className="m-0 p-0">
              <Col xs={12} lg={12} className="m-0 p-0 pt-1 pb-1">
                <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont11">
                  <small class="Font12 ps-4" title={"Dasha Period   :"+clientData.currentDashaPeriod+"\nDasha Balance :"+clientData.currentDashaBalance}>
                    Dasha:{clientData.currentDashaName}({clientData.currentDashaStart.substring(0,10)} to {clientData.currentDashaEnd.substring(0,10)})
                  </small>
                  <small class="Font12 ps-2" title={"Bhukti Period   :"+clientData.currentBhuktiPeriod+"\nBhukti Balance :"+clientData.currentBhuktiBalance}>
                    Bhukti:{clientData.currentBhuktiName}({clientData.currentBhuktiStart.substring(0,10)} to {clientData.currentBhuktiEnd.substring(0,10)})
                  </small>
                  <small class="Font12 ps-2" title={"Andharam Period   :"+clientData.currentAndharamPeriod+"\nAndharam Balance :"+clientData.currentAndharamBalance}>
                    Andharam:{clientData.currentAndharamName}({clientData.currentAndharamStart.substring(0,10)} to {clientData.currentAndharamEnd.substring(0,10)})
                  </small>
                </table>
              </Col>
            </Row> 

            <form method="post" onSubmit={handleSubmit}>
            {loop.map((row, rowindex) => (
              <Row id="prosperity" className="m-0 p-2 pt-0">
              {loop.map((col, colindex) => (
                <Col xs={12} lg={4} class="m-0 p-2 pb-2">
                  
                  <table class="table table-bordered table-hover align-middle caption-top p-0 m-0 text-center TableFont11">
                  <thead>
                    <tr class="m-0 p-0" >
                      <th class="m-0 p-0 align-middle"></th> 
                      <th class="m-0 p-0 align-middle">Planet</th> 
                      <th class="m-0 p-0 align-middle">CL</th> 
                      <th class="m-0 p-0 align-middle">OCC</th> 
                      <th class="m-0 p-0 align-middle">CST</th> 
                      <th class="m-0 p-0 align-middle" >CSL</th> 
                      {showColumn===false?<></>:
                        <th class="m-0 p-0 align-middle" >
                        <Form.Select class="m-0 p-0 border-0" size="sm" name={"category"+(rowindex*3+colindex)} value={planetCategory[rowindex*3+colindex]} style={{backgroundColor:eventData.allPlanetCategory[planetCategory[rowindex*3+colindex]][2], color:eventData.allPlanetCategory[planetCategory[rowindex*3+colindex]][3] }} onChange={(event)=>handleColorInput(event,rowindex*3+colindex)} >
                          {eventData.allPlanetCategory.map((category,index) => (
                            <option class="text-start m-0 p-0" size="sm" key={index} value={index}  style={{backgroundColor:category[2], color:category[3] }} >{category[1]}</option>
                          ))}
                        </Form.Select>
                        </th>
                      } 
                    </tr>
                  </thead>
                  <tbody>
                    {
                      prosData!==null&&prosData[rowindex*3+colindex]!==null&&prosData[rowindex*3+colindex]!==undefined&&
                        prosData[rowindex*3+colindex].map((planet,planetIndex) => (
                        <>{planet===null||planet===undefined?<></>:
                          <>
                          <tr class={planet.split(',')[0]!=="2"&&planet.split(',')[0]!=="4"?"p-0 bg-light":"p-0"} style={planet.split(',')[1]==="2"?{"border-bottom": 'none'}:planet.split(',')[1]==="0"?{"border-top": 'none'}:{}}>
                            <th class="bg-transparent text-start m-0 p-0 ps-2">{planet.split(',')[2]}</th>
                            <td class="text-start m-0 p-0 ps-2" style={showPlanetColor?{'background-color':planet.split(',')[9], 'color':planet.split(',')[10]}:{}}>{planet.split(',')[3]}</td>
                            <td class="bg-transparent text-start m-0 p-0 ps-2 text-nowrap">{getTag(planet.split(',')[4])}</td>
                            <td class="bg-transparent text-start m-0 p-0 ps-2 text-nowrap">{getTag(planet.split(',')[5])}</td>
                            <td class="bg-transparent text-start m-0 p-0 ps-2 text-nowrap">{getTag(planet.split(',')[6])}</td>
                            <td class="bg-transparent text-start m-0 p-0 ps-2 text-nowrap">{getTag(planet.split(',')[7])}</td>
                            {showColumn===false?<></>:
                            <td class="bg-transparent text-start m-0 p-0 ps-2">{planet.split(',')[8]===""?"":isMobile?eventData.allPlanetCategory[planet.split(',')[8]][1]:eventData.allPlanetCategory[planet.split(',')[8]][0]}</td>
                            }
                          </tr>
                          </>}
                        </>
                      ))
                    }
                  </tbody>
                  </table>
                </Col>
              ))}
              </Row>
            ))}
            {showColumn===false?<></>:
            <Row id="significators" className="m-0 p-0 pt-3">
              <Col xs={12} lg={3} className="m-0 p-0"></Col>
              <Col xs={12} lg={6} className="m-0 p-0 text-center">
                <SubmitResetClearButton callback={handleClear} callbackReset={handleReset} /> 
              </Col>
              <Col xs={12} lg={3} className="m-0 p-0"></Col>
            </Row>
            }
            </form>
          </Col>
        </Row>
      </Collapse>
    }
    <ShowGenericAlertError errorAlert={errorMessage} setErrorAlert={setErrorMessage} msgtitle={msgtitle}
        msgbody={msgbody} msgbutton={msgbutton} callback={handleAlertCallback}/>
  </>
  )
}